import { selectors } from '#hooks'

const buildHtml = (title, siteName, description, body, h1) => {
  const sanitizedTitle = title && title.replace(/<[^>]*>?/gm, '')
  const sanitizedDescription =
    description && description.replace(/<[^>]*>?/gm, '')
  const sanitizedH1 = h1 && h1.replace(/<[^>]*>?/gm, '')
  const titleFormatted =
    sanitizedTitle && sanitizedTitle.length > 0
      ? '<title>' + sanitizedTitle + ' - ' + siteName + '</title>'
      : ''
  const h1Formatted = sanitizedH1 && sanitizedH1.length > 0 ? sanitizedH1 : ''
  const descriptionFormatted =
    sanitizedDescription && sanitizedDescription.length > 0
      ? `<meta name="description" content="${sanitizedDescription}">`
      : ''

  return `
    <!DOCTYPE html>
    <html>
        <head>
            ${titleFormatted}
            ${descriptionFormatted}
        </head>
        <body>
            <h1>${h1Formatted}</h1>
            ${body}
        </body>
    </html>

`
}

export const log = (data) => {
  console.log(data)
}

export const createBodyToCheck = (data) => {
  if (!data) return null

  const { data: post } = data

  return {
    html_body: btoa(
      unescape(
        encodeURIComponent(
          buildHtml(
            post.title?.rendered,
            window.marketgoo.siteName,
            post.postMetaFields?.[selectors.description]?.[0] || '',
            post.content?.rendered
              .replace(/(\r\n|\n|\r)/gm, ' ')
              .replace(/\s+/g, ' '),
            post.title?.rendered
          )
        )
      )
    ),
    keyword: post.postMetaFields?.[selectors.keyword]?.[0] || '',
    slug: post.slug,
  }
}

export const formatTasks = (tasks) => {
  if (!tasks) {
    return null
  }

  return tasks?.reduce(
    (acc, task) => ({
      ...acc,
      [task.id]: task.pass,
    }),
    {}
  )
}
